package team.platforma.multiplatform_material_extension.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember


@Composable
internal fun rememberStringValidator(): StringValidator {
    return remember { StringValidator() }
}

internal class StringValidator {
    fun showMessage(
        userInput: Boolean,
        validateResult: Boolean,
        required: Boolean,
        inputString: String,
        messageDisplaySymbols: Int
    ): Boolean {
        if (required) {
            if (userInput) {
                if (inputString.length < messageDisplaySymbols) {
                    return true
                } else {
                    return !validateResult
                }

            } else {

                return false
            }

        } else {
            if (userInput) {
                if (inputString.isEmpty()) {
                    return false
                } else if (inputString.length < messageDisplaySymbols) {
                    return true
                } else {
                    return !validateResult
                }

            } else {
                return false
            }
        }
    }


    fun isErrorInput(
        userInput: Boolean,
        validateResult: Boolean,
        required: Boolean,
        inputString: String
    ): Boolean {
        if (required) {
            if (inputString.isNotEmpty()) {
                return userInput && !validateResult
            } else {
                return true
            }

        } else {
            if (inputString.isEmpty()) {
                return false
            } else {
                return userInput && !validateResult
            }
        }
    }

    fun createResultValidation(required: Boolean, validateStringResult: Boolean, string: String, minSymbols: Int): Boolean {
        if (required) {
            return validateStringResult && string.length >= minSymbols
        } else {
            if (string.isNotEmpty()) {
                return validateStringResult && string.length >= minSymbols
            } else {
               return true
            }
        }
    }

    fun createValidateStringResult(required: Boolean, inputString: String, regex: Regex): Boolean {
        return if (required) {
            validateStringByRegex(inputString, regex)
        } else {
            if (inputString.isNotEmpty()) {
                validateStringByRegex(inputString, regex)
            } else {
                true
            }
        }
    }

    fun createValidateStringResult(required: Boolean, inputString: String, regexList:List<Regex>): Boolean {
        var validateResult = false
         if (required) {

             for (i in regexList.indices) {
                 if (validateStringByRegex(inputString, regexList[i])) {
                     validateResult = true
                     break
                 } else {
                     validateResult = false
                 }
             }

           return validateResult

        } else {
            if (inputString.isNotEmpty()) {
                for (i in regexList.indices) {
                    if (validateStringByRegex(inputString, regexList[i])) {
                        validateResult = true
                        break
                    } else {
                        validateResult = false
                    }
                }

                return validateResult
            } else {
               return true
            }
        }
    }

    fun validateStringByRegex(string: String, regex: Regex): Boolean {
        return string.matches(regex)
    }

}